<div class="h-100 table-with-header">
    <div *ngIf="headerType === 'paginationDetails'" class="card pag-details d-flex flex-row px-2 mb-3">
        <span class="pagination-label align-content-center flex-grow-1 px-1" [innerHTML]="tablePaginationLabel"></span>
        <div class="actions-wrap align-content-center">
            <button *ngIf="viewId === 'reclaim_execution_engine_list'" class="btn-accello-secondary my-2" (click)="onReclaim()">
                <img src="assets/images/virtusa-icons/reclaim.png" alt="reclaim">
                Reclaim
            </button>
        </div>
    </div>

    <div *ngIf="headerType === 'coverageDetails'" class="card pag-details d-flex flex-row px-2 mb-3 d-flex align-content-center justify-content-between">
        <span class="pagination-label align-content-center" [innerHTML]="tablePaginationLabel"></span>
        
        <div class="progress-bar-section" *ngIf="showProgressBar">
            <span class="progress-label">{{ progressBarLabel }}</span>
            <div class="progress-bar-div w-100">
                <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="progressBarValue"></div>
                </div>
                <span class="progress-percentage">{{ progressBarValue }}%</span>
            </div>

            <div class="vertical-divider"></div>
            
            <button class="btn-accello-secondary" *ngIf="showSaveButton"
                    (click)="onHighImpactSave()"
                    [disabled]="isHighImpactSaveLoading"
                    [class.tph-save-btn--disabled]="isHighImpactSaveLoading">
                <span *ngIf="isHighImpactSaveLoading" class="tph-save-spinner"></span>
                <ng-container *ngIf="!isHighImpactSaveLoading">
                <img src="assets/images/virtusa-icons/save-icon.svg" alt="save" class="tph-save-icon" />
                </ng-container>
                {{ isHighImpactSaveLoading ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>

    <div class="table-wrap">
        <app-zorro-table
            [columns]="columns"
            [data]="rows"
            [tableId]="viewId"
            [options]="meta?.table?.options"
            [borderColor]="meta?.table?.borderColor"
            [hideVerticalBorder]="meta?.table?.hideVerticalBorder"
            [hideTopBottomLines]="meta?.table?.hideTopBottomLines"
            [options]="{ showSelection: true }"
            [hideHeaders]="meta?.table?.hideHeaders"
            [whiteHeaderBg]="meta?.table?.whiteHeaderBg"
            (handleActions)="onTableAction($event)"
            (onRowSelect)="onTableAction($event)"
            (pageChange)="onTablePageChange($event)"
        ></app-zorro-table>
    </div>
</div>
